import React from 'react';
import Popup from '../Popup';
import styles from './InformationPopup.styles';
import Button from '../../button/Button';
import Icons from '../../icons/Icons';
import HorizontalSeparator from '../../separator/horizontalSeparator/HorizontalSeparator';
import { BUTTON_TYPE } from '../../button/constants';
import General from '../../../../libs/utility/General';
import Loadable from '../../loadable/Loadable';

export default function InformationPopup({
    title,
    bodyText,
    iconName = '',
    isOpen,
    confirmationButtonProps = {
        onConfirmationCb: () => { },
        confirmationButtonText: "Submit",
        confirmationButtonStyles: {},
        confirmationButtonType: BUTTON_TYPE.PRIMARY,
    },
    customStyle = {},
    isClose = true,
    onCloseCb = () => {},
    loadingState=false,
    loaderLoadingStates=[],
    loaderMessageMap={},
    preserveLoaderChildMount=false,
    showClose=false,
    children,
    customBodyContainerStyle = {},
    customBodyTextStyle={},
}) {
    return (

        <Popup title={title} onCloseCb={onCloseCb} showClose={showClose} isPopupOpen={isOpen} customPopupSyles={customStyle} childrenStyles={styles.popupChildrenContainer}>
            <Loadable
                currentState={loadingState?.state}
                loadingStates={loaderLoadingStates} 
                isNewLoadable={true}
                messageMap={loaderMessageMap}
                preserveChildMount={preserveLoaderChildMount}
            >
                <div style={{...styles.bodyContainer, ...customBodyContainerStyle}}>

                    {iconName && <div>
                        <Icons familyName='vec' iconName={iconName} />
                    </div>}

                    {bodyText && <span style={{...styles.bodyText, ...customBodyTextStyle}}>{<p style={styles.innerHtmlContent} dangerouslySetInnerHTML={{ __html: General.sanitizeContent(bodyText) }} />}</span>}
                    {children}
                </div>

                <HorizontalSeparator style={styles.separatorLine} />

                <div style={styles.footer}>

                    {confirmationButtonProps.confirmationButtonText && <div onClick={confirmationButtonProps.onConfirmationCb}>
                        <Button
                            type={confirmationButtonProps.confirmationButtonType}
                            style={{ ...confirmationButtonProps.confirmationButtonStyles, ...styles.button }}
                        >
                            {confirmationButtonProps.confirmationButtonText}
                        </Button>
                    </div>}

                </div>
            </Loadable>
        </Popup>
    )
}